import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { OfficerShellComponent } from './layout/officer-shell.component';
import { AuthCallbackComponent } from './pages/auth-callback.component';
import { DashboardComponent } from './pages/dashboard.component';
import { EventCreateWizardComponent } from './pages/event-create-wizard.component';
import { EventTicketCreateComponent } from './pages/event-ticket-create.component';
import { EventCategoriesComponent, EventsComponent, EventsDraftComponent } from './pages/events.component';
import { EventWorkspaceComponent } from './pages/event-workspace.component';
import { FlowsComponent } from './pages/flows.component';
import { GuestsComponent } from './pages/guests.component';
import { LoginComponent } from './pages/login.component';
import { MarketingComponent } from './pages/marketing.component';
import { MembersComponent } from './pages/members.component';
import { MembershipPlansComponent } from './pages/membership-plans.component';
import { PortfolioCollectionsComponent, PortfolioProjectsComponent } from './pages/projects.component';
import {
  SalesAnalyticsEventsComponent,
  SalesAnalyticsMembershipsComponent,
  SalesAnalyticsOverviewComponent,
  SalesAnalyticsStoreFutureComponent,
  SalesOrdersComponent,
  SalesMembershipsComponent,
  SalesMerchandiseFutureComponent,
  SalesPaymentsAllComponent,
  SalesPaymentsReceiptsFutureComponent
} from './pages/sales-sections.component';
import { WcHomeComponent, WcAboutComponent, WcSettingsComponent, WcAnnouncementsComponent } from './pages/website-content-sections.component';
import { StoreCatalogComponent } from './pages/store-catalog.component';
import { BoardOfDirectorsComponent } from './pages/board-of-directors.component';
import { PresidentsComponent } from './pages/presidents.component';
import { ReportsComponent } from './pages/reports.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: '',
    component: OfficerShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'events', pathMatch: 'full', redirectTo: 'events/published' },
      { path: 'events/new', component: EventCreateWizardComponent },
      { path: 'events/published', component: EventsComponent },
      { path: 'events/draft', component: EventsDraftComponent },
      { path: 'events/categories', component: EventCategoriesComponent },
      { path: 'events/:id/tickets/new', component: EventTicketCreateComponent },
      { path: 'events/:id', redirectTo: 'events/:id/overview', pathMatch: 'full' },
      { path: 'events/:id/features/schedule', component: EventWorkspaceComponent },
      { path: 'events/:id/guests/add', component: EventWorkspaceComponent },
      { path: 'events/:id/guests/:guestId', component: EventWorkspaceComponent },
      { path: 'events/:id/orders/:orderId', component: EventWorkspaceComponent },
      { path: 'events/:id/:tab', component: EventWorkspaceComponent },
      { path: 'sales', pathMatch: 'full', redirectTo: 'sales/orders' },
      { path: 'sales/orders', component: SalesMerchandiseFutureComponent },
      { path: 'sales/merchandise', component: SalesMerchandiseFutureComponent },
      { path: 'sales/events', component: SalesOrdersComponent },
      { path: 'sales/memberships', component: SalesMembershipsComponent },
      { path: 'sales/payments/all', component: SalesPaymentsAllComponent },
      { path: 'sales/payments/receipts', component: SalesPaymentsReceiptsFutureComponent },
      { path: 'sales/analytics/overview', component: SalesAnalyticsOverviewComponent },
      { path: 'sales/analytics/store', component: SalesAnalyticsStoreFutureComponent },
      { path: 'sales/analytics/events', component: SalesAnalyticsEventsComponent },
      { path: 'sales/analytics/memberships', component: SalesAnalyticsMembershipsComponent },
      { path: 'projects', pathMatch: 'full', redirectTo: 'projects/projects' },
      { path: 'projects/projects', component: PortfolioProjectsComponent },
      { path: 'projects/collections', component: PortfolioCollectionsComponent },
      { path: 'marketing', pathMatch: 'full', redirectTo: 'marketing/seo-geo' },
      { path: 'marketing/:section', component: MarketingComponent },
      { path: 'people', pathMatch: 'full', redirectTo: 'people/members' },
      { path: 'people/members', component: MembersComponent },
      { path: 'people/guests', component: GuestsComponent },
      { path: 'members', pathMatch: 'full', redirectTo: 'people/members' },
      { path: 'members/:id', loadComponent: () => import('./pages/member-profile.component').then(m => m.MemberProfileComponent) },
      { path: 'commerce', pathMatch: 'full', redirectTo: 'commerce/store-catalog' },
      { path: 'commerce/store-catalog', component: StoreCatalogComponent },
      { path: 'commerce/membership-plans', component: MembershipPlansComponent },
      { path: 'membership-plans', pathMatch: 'full', redirectTo: 'commerce/membership-plans' },
      {
        path: 'analytics',
        loadComponent: () =>
          import('./pages/analytics.component').then((m) => m.AnalyticsComponent)
      },
      { path: 'flows', component: FlowsComponent },
      { path: 'website-content', pathMatch: 'full', redirectTo: 'website-content/home' },
      { path: 'website-content/home',          component: WcHomeComponent },
      { path: 'website-content/about',         component: WcAboutComponent },
      { path: 'website-content/settings',      component: WcSettingsComponent },
      { path: 'website-content/announcements', component: WcAnnouncementsComponent },
      { path: 'organisation/board-of-directors', component: BoardOfDirectorsComponent },
      { path: 'organisation/presidents',         component: PresidentsComponent },
      { path: 'reports', component: ReportsComponent }
    ]
  },
  { path: '**', redirectTo: '' }
];
